import useSWR from 'swr';
import { SwrReturnType } from '~/models/Api';
import { DealEstimationHistoryContext } from '~/models/DealEstimationHistory';

const paths = {
  index: '/vendors/deals/:deal_id/deal_estimation_histories'
};
type TIndex = (
  dealId: number | null
) => SwrReturnType<DealEstimationHistoryContext>;
type ReturnType = {
  index: TIndex;
};

export const useDealEstimationHistories = (): ReturnType => {
  const index: TIndex = (dealId: number | null) => {
    const { data, mutate, isLoading, error } =
      useSWR<DealEstimationHistoryContext>(
        dealId === null ? null : paths.index.replace(':deal_id', String(dealId))
      );
    return {
      data: data ?? null,
      mutate,
      isLoading,
      error
    };
  };
  return { index };
};
